import {UserHomepageComponentTypes} from "../../ui/containers/user-homepage/models";

const MOCK_IMAGE_CAROUSEL_COMPONENT_ID = 900001;

/**
 * Local-dev mock image carousel row for homepage edition preview / control panel.
 */
export const mockHomeImageCarouselComponent = {
    id: MOCK_IMAGE_CAROUSEL_COMPONENT_ID,
    title: 'Shop by Brand (mock)',
    orderIndex: 50,
    type: {
        id: UserHomepageComponentTypes.imageCarousel,
        title: 'Image Carousel',
    },
    content: {
        imageWidth: 140,
        imageHeight: 90,
        images: [
            {
                id: 900101,
                orderIndex: 1,
                fileGuid: 'mock-carousel-brand-a',
                fileExtension: 'png',
                mockPreviewUrl: 'https://placehold.co/140x90/583F99/ffffff/png?text=Brand+A',
                tags: [
                    {id: 900201, name: 'Brand A', industryId: 1, iconFileName: null},
                ],
            },
            {
                id: 900102,
                orderIndex: 2,
                fileGuid: 'mock-carousel-brand-b',
                fileExtension: 'png',
                mockPreviewUrl: 'https://placehold.co/140x90/362661/ffffff/png?text=Brand+B',
                tags: [
                    {id: 900202, name: 'Brand B', industryId: 1, iconFileName: null},
                ],
            },
            {
                id: 900103,
                orderIndex: 3,
                fileGuid: 'mock-carousel-brand-c',
                fileExtension: 'png',
                mockPreviewUrl: 'https://placehold.co/140x90/FF9234/ffffff/png?text=Brand+C',
                tags: [
                    {id: 900203, name: 'Brand C', industryId: 1, iconFileName: null},
                ],
            },
            {
                id: 900104,
                orderIndex: 4,
                fileGuid: 'mock-carousel-decor',
                fileExtension: 'png',
                mockPreviewUrl: 'https://placehold.co/140x90/E8E8E8/666666/png?text=Decor',
                tags: [],
            },
        ],
    },
};

export const hasMockHomeImageCarousel = (components = []) =>
    components.some((component) => component?.type?.id === UserHomepageComponentTypes.imageCarousel);

/**
 * Injects mock carousel into homepage edition API payload.
 * @param {any} data
 * @param {number | undefined} tabId
 * @return {any}
 */
export const injectMockHomeImageCarouselEdition = (data, tabId = undefined) => {
    if (!data?.tabs?.length) {
        return data;
    }

    const injectIntoTab = (tab) => {
        const components = tab?.components ?? [];
        if (hasMockHomeImageCarousel(components)) {
            return tab;
        }
        return {
            ...tab,
            components: [
                ...components,
                mockHomeImageCarouselComponent,
            ],
        };
    };

    if (tabId != null) {
        return {
            ...data,
            tabs: data.tabs.map((tab) => tab.id === tabId ? injectIntoTab(tab) : tab),
        };
    }

    return {
        ...data,
        tabs: data.tabs.map((tab, index) => index === 0 ? injectIntoTab(tab) : tab),
    };
};
